export interface DriverRegistrationData {
  phone: string;
  phone_verification_token: string;
  full_name: string;
  email: string;
  date_of_birth: string;
  address: string;
  national_id: string;
  license_number: string;
  license_expiry: string;
  driving_experience: string;
  license_front_url: string | null;
  license_back_url: string | null;
  vehicle_model: string;
  license_plate: string;
  vehicle_registration: string;
  vehicle_make: string;
  vehicle_color: string;
  vehicle_year: string;
  vehicle_photos: string[];
  bank_name: string;
  account_number: string;
  account_name: string;
  criminal_record_check: boolean;
  driving_record_check: boolean;
  profile_photo_url: string | null;
  password: string;
  confirm_password: string;
}

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';

class DriverApiService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = API_BASE_URL;
  }

  async registerDriver(driverData: DriverRegistrationData): Promise<any> {
    const response = await fetch(`${this.baseUrl}/api/v1/drivers/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(driverData),
    });

    const responseData = await response.json();

    if (!response.ok) {
      throw new Error(responseData.detail || `Registration failed: ${response.status}`);
    }

    return responseData;
  }

  async uploadFiles(files: File[]): Promise<{ uploaded_urls: string[] }> {
    const formData = new FormData();
    files.forEach(file => formData.append('files', file));

    const response = await fetch(`${this.baseUrl}/api/v1/drivers/upload-files`, {
      method: 'POST',
      body: formData,
    });

    const responseData = await response.json();

    if (!response.ok) {
      throw new Error(responseData.detail || 'File upload failed');
    }

    return responseData;
  }
}

export const driverApi = new DriverApiService();